<template>
    <div id="trx-d2d-container">
      <f7-list form class="form-group" v-show="showFormSet.doorToDoor">

        <f7-list-input
            input-id     ="street"
            name         ="street"
            type         ="text"

            :label       ="$t('beneficiary-street')"
            :placeholder ="$t('beneficiary-street')"
            :value       ="street"
            @input       ="setStreet($event.target.value); validateInput($event.target); setInput($event.target)"
            autocomplete ="off"
            maxlength    ="100"
            outline
            floating-label
            clear-button
        ></f7-list-input>
        <f7-list-input
            input-id     ="postcode"
            name         ="postcode"
            type         ="number"

            :label       ="$t('beneficiary-postcode-optional')"
            :placeholder ="$t('beneficiary-postcode-optional')"
            :value        ="postcode"
            @input       ="setPostcode($event.target.value); validateInput($event.target); setInput($event.target)"
            autocomplete ="off"
            maxlength    ="15"
            outline
            floating-label
            clear-button
        ></f7-list-input>
        <f7-list-input
            input-id     ="locatingNote"
            name         ="locatingNote"
            type         ="text"

            :label       ="$t('beneficiary-locating-note-optional')"
            :placeholder ="$t('beneficiary-locating-note-optional')"
            :value       ="locatingNote"
            @input       ="setLocatingNote($event.target.value); validateInput($event.target); setInput($event.target);"

            outline
            floating-label
            clear-button
        ></f7-list-input>

        <f7-list-input
            input-id     ="landmark"
            name         ="landmark"
            type         ="text"

            :label       ="$t('beneficiary-landmark-optional')"
            :placeholder ="$t('beneficiary-landmark-optional')"
            :value       ="landmark"
            @input       ="setLandmark($event.target.value); validateInput($event.target); setInput($event.target);"

            maxlength    ="100"
            outline
            floating-label
            clear-button
        ></f7-list-input>
    </f7-list>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    props: {
      
    },
    mounted (){
      
    },
    data: function () {
      return {
      }
    },
    computed: {
      ...mapGetters('transaction', [
          'showFormSet',
          'showFormInput',
          'street',
          'postcode',
          'showPreloaderState',
          'locatingNote',
          'landmark',
      ])
    },
    methods: {
      ...mapActions('transaction', [
          'setStreet',
          'setPostcode',
          'setShowPreloaderState',
          'setLocatingNote',
          'setLandmark'
      ]),

      validateInput(inputEl){
        this.showPreloader();
        this.$emit("validateInput", inputEl);
        this.hidePreloader();
      },

      setInput(inputEl){
        this.$emit("setInput", inputEl);
      }
    }
  }
</script>